export default "__VITE_ASSET__CPcNuKCj__"